<h1 matDialogTitle>Confirm Delete</h1>
<div mat-dialog-content fxLayoutAlign="center center">
  <span>Are you sure you want to {{data.action}}?</span>
</div>
<div mat-dialog-actions [fxLayoutAlign]="'space-around center'">
  <button mat-button mat-raised-button (click)="cancel()">Cancel</button>
  <button mat-button mat-raised-button color="primary" (click)="confirm()">Delete</button>
</div>